/* 不同--俱乐部--配置文件，根据process.env.VUE_APP_AUDIENCE判断 */
let CONFIG = {
    ELITE: {
        productName: 'ACME<br/>ManagePilot', // 下载软件的名称
        productNameEn: 'ACME<br/>ManagePilot', // 下载软件的名称
        productImg: require('../logo.png'), // 下载软件的图片
        loginBackground: require('@i/ui_config/elite-background.png'), //登录背景

        logo: require('@i/ui_config/elite-logo.svg'), //系统logo
        defaultAvatar: require('@i/common/default_avatar.svg'),
        color: '#122A88',
        loginSucGif: require('@i/ui_config/origin-login-success.gif'), //登录成功动画

        HomePersonBg: require('@i/ui_config/origin-home-person-background.png'), // 首页登录人信息背景
        scheduleBackground: require('@i/ui_config/origin-schedule-background.png'), // 梯队赛程背景logo
        QRBackground: require('@i/ui_config/origin-qr-background.png'), // 教练员二维码背景图
        exportPdfBg: require('@i/ui_config/origin_export_pdf_bg.svg'), // 导出pdf背景图
        playerVideoBg: require('@i/ui_config/origin-player-video-bg.svg'), // 球员视频统计头部背景图
    },
};
// 暴露UI CSS层面的内容
export default CONFIG[process.env.VUE_APP_AUDIENCE];
